import { render, staticRenderFns } from "./memberExcellent.vue?vue&type=template&id=b217b1e2&scoped=true&"
import script from "./memberExcellent.vue?vue&type=script&lang=js&"
export * from "./memberExcellent.vue?vue&type=script&lang=js&"
import style0 from "./memberExcellent.vue?vue&type=style&index=0&id=b217b1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b217b1e2",
  null
  
)

export default component.exports